const EOpticAndCameraFeature = Object.freeze({
    Unknown: "Unknown",

    //------COMMON---------//

    Exposure: "exposure",
    Gamma: "gamma",
    Gain: "gain",
    Binning: "binning",
    TotalZoom: "totalZoom",

    //------SONICC---------//

    SoniccExposure: "soniccExposure",
    LaserPower: "laserPower",
    Photosensor: "photoSensor",

    //------Visible---------//

    ContinuousZoom: "continuousZoom",
    CropZoom: "cropZoom",
    Condenser: "condenser",
    Polarizer: "polarizer",
    CrossPolarizer: "crossPolarizer",
    Brightness: "brightness",

    //------UV-------------//

    ObjectiveZoom: "objectiveZoom",
    Illumination: "illumination",

    //------MFI------------//

    FilterCubes: "filterCubes",
    FilterCube: "filterCube",    
});

export default EOpticAndCameraFeature;